/**
 * Simplified hash functions for various data types, based on the Web Crypto API
 * and `crypto` package in Node.js.
 * @module
 */
import bytes from "./bytes.ts";
import { isDeno, isNodeLike } from "./env.ts";
import { hash, hmac as _hmac, toBytes, sha1 as _sha1, sha256 as _sha256, sha512 as _sha512 } from "./hash/web.ts";
export default hash;
async function nodeHash(algorithm, data, encoding = undefined) {
    const crypto = await import("node:crypto");
    const bytes = await toBytes(data);
    const hash = crypto.createHash(algorithm);
    hash.update(bytes);
    if (encoding) {
        return hash.digest(encoding);
    }
    else {
        const result = hash.digest();
        // Truncate the buffer to the actual byte length so it's consistent with the web API.
        return result.buffer.slice(result.byteOffset, result.byteOffset + result.byteLength);
    }
}
export async function sha1(data, encoding = undefined) {
    if (typeof crypto === "object") {
        return encoding ? _sha1(data, encoding) : _sha1(data);
    }
    else if (isDeno || isNodeLike) {
        return nodeHash("sha1", data, encoding);
    }
    else {
        throw new Error("Unsupported runtime");
    }
}
export async function sha256(data, encoding = undefined) {
    if (typeof crypto === "object") {
        return encoding ? _sha256(data, encoding) : _sha256(data);
    }
    else if (isDeno || isNodeLike) {
        return nodeHash("sha256", data, encoding);
    }
    else {
        throw new Error("Unsupported runtime");
    }
}
export async function sha512(data, encoding = undefined) {
    if (typeof crypto === "object") {
        return encoding ? _sha512(data, encoding) : _sha512(data);
    }
    else if (isDeno || isNodeLike) {
        return nodeHash("sha512", data, encoding);
    }
    else {
        throw new Error("Unsupported runtime");
    }
}
export async function md5(data, encoding = undefined) {
    if (isDeno || isNodeLike) {
        return nodeHash("md5", data, encoding);
    }
    else {
        throw new Error("Unsupported runtime");
    }
}
export async function hmac(algorithm, key, data, encoding = undefined) {
    if (typeof crypto === "object") {
        return encoding ? _hmac(algorithm, key, data, encoding) : _hmac(algorithm, key, data);
    }
    else if (isDeno || isNodeLike) {
        const crypto = await import("node:crypto");
        const binary = await toBytes(data);
        const hash = crypto.createHmac(algorithm, bytes(key));
        hash.update(binary);
        if (encoding) {
            return hash.digest(encoding);
        }
        else {
            const result = hash.digest();
            // Truncate the buffer to the actual byte length so it's consistent with the web API.
            return result.buffer.slice(result.byteOffset, result.byteOffset + result.byteLength);
        }
    }
    else {
        throw new Error("Unsupported runtime");
    }
}
//# sourceMappingURL=hash.js.map